import React from "react"
import TopNavBar from '../Shared/TopNavBar'
import { Translate } from "../../translate/Translate";
import StepArea from "./StepArea"

export default function NewPropertySteps(props) {
    
    const [homeExample, setHomeExample] = React.useState({
        "area": {
            "id": "karuizawa"
        },
    });
    const onSelectedArea = (name, value) => {
        setHomeExample({ ...homeExample, area: {id: value} })
    }

    const [step, setCurrentStep] = React.useState(props.history.location.hash ? Number(props.history.location.hash.replace("#","")) : 0);
    const totalStep = 1 // area > type
    const next = () => {
        setCurrentStep(step + 1);
    }

    const back = () => {
        setCurrentStep(step - 1);
    }

    React.useEffect(() => {
        props.history.replace("#" + step)

        if (step === totalStep) {
            props.history.replace({
                pathname: '/example/new',
                search: '?data=' + JSON.stringify(homeExample),
                state: {}
              })
        }
    },[step]);

    
    return (
        <div className="">
            <TopNavBar active="listing"></TopNavBar>
            <div className="mt-16 mb-16 w-full container mx-auto py-8 px-4">
            <div className="mb-8 flex justify-between items-center">
                    <div>
                        <div className="flex flex-row mb-1">
                            <button type="button" onClick={(e) => { props.history.goBack() }} className="text-xs uppercase font-medium text-gray-600 inline-flex items-center">
                                <svg className="fill-current text-gray-600 mr-2" width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.890625 5.76953C0.890625 5.91602 0.943359 6.04492 1.05469 6.15625L5.70117 10.6973C5.80078 10.8027 5.92969 10.8555 6.08203 10.8555C6.38672 10.8555 6.62109 10.627 6.62109 10.3223C6.62109 10.1699 6.55664 10.041 6.46289 9.94141L2.19727 5.76953L6.46289 1.59766C6.55664 1.49805 6.62109 1.36328 6.62109 1.2168C6.62109 0.912109 6.38672 0.683594 6.08203 0.683594C5.92969 0.683594 5.80078 0.736328 5.70117 0.835938L1.05469 5.38281C0.943359 5.48828 0.890625 5.62305 0.890625 5.76953Z" />
                                </svg>
                                <span>{Translate("Listing")}</span>
                            </button>
                        </div>

                        <p className="text-2xl font-semibold">{Translate("Create new property")}</p>
                    </div>
                </div>
                {
                    step === 0 ?
                    <StepArea options={props.areas} onSelected={onSelectedArea} data={homeExample} area={homeExample.area}></StepArea>
                    : null
                }
                
                <div className="w-full mt-8 flex gap-4">
                    {
                        step > 0 ?
                        <button type="button" onClick={(e) => back()} className="py-3 font-semibold bg-gray-300 text-gray-600 rounded w-full">{Translate("Back")}</button>
                        : null
                    }
                    
                    <button type="button" onClick={(e) => next()} className="py-3 font-semibold bg-blue-600 text-white rounded w-full">{Translate("Next")}</button>
                </div>

            </div>
        </div>
    )
}